/* eslint-disable */

export const protobufPackage = "tecton_proto.configurationcheck";

/** Next id: 5 */
export enum CheckId {
  CHECK_ID_UNSPECIFIED = "CHECK_ID_UNSPECIFIED",
  CHECK_ID_TEST_VALUE = "CHECK_ID_TEST_VALUE",
  CHECK_ID_TESTONLY_DATABASE_CONNECTIVITY = "CHECK_ID_TESTONLY_DATABASE_CONNECTIVITY",
  CHECK_ID_TESTONLY_CONFIGURATION_VALIDATION = "CHECK_ID_TESTONLY_CONFIGURATION_VALIDATION",
  /** CHECK_ID_CAN_ASSUME_CROSS_ACCOUNT_ROLES - Add new values below (and increment the next id, above) */
  CHECK_ID_CAN_ASSUME_CROSS_ACCOUNT_ROLES = "CHECK_ID_CAN_ASSUME_CROSS_ACCOUNT_ROLES",
}

export enum ResultStatus {
  RESULT_STATUS_UNSPECIFIED = "RESULT_STATUS_UNSPECIFIED",
  RESULT_STATUS_PASSED = "RESULT_STATUS_PASSED",
  RESULT_STATUS_FAILED = "RESULT_STATUS_FAILED",
  RESULT_STATUS_UNKNOWN = "RESULT_STATUS_UNKNOWN",
}

/**
 * This message is used as the output of MDS' gRPC interface.
 * The input (used by the "manager" class) uses a different mechanism.
 */
export interface CheckResult {
  short_name?: string | undefined;
  description?: string | undefined;
  start_time?: string | undefined;
  status?: ResultStatus | undefined;
  error_message?: string | undefined;
  last_passed_time?: string | undefined;
}

export interface CheckRun {
  completed_time?: string | undefined;
  check_results?: CheckResult[] | undefined;
}
